module.exports = __webpack_public_path__ + "img/reglementation-icon.88cc09bf.png";